module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1088.ad336a1e.png";